import { Injectable, Output, EventEmitter, OnDestroy, Directive, Optional } from '@angular/core';
import { OrganizationService } from '../../../api';
import { ProfileService } from './../../../core/profile/profile.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive()
@Injectable({
  providedIn: 'root'
})
export class CreditsService implements OnDestroy {
  @Output() onCreditsChange: EventEmitter<number> = new EventEmitter<number>()

  private _credits: number = 0;
  get credits(): number {
    return this._credits;
  }

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    @Optional()
    private _organizationApi: OrganizationService,
    @Optional()
    private _profile: ProfileService
  ) { }

  update() {
    this._organizationApi.organizationGetAvailableCredits(this._profile.getToken())
      .pipe(takeUntil(this.destroy$)).subscribe(
        (response: any) => {
          this._credits = response.data;
          this.onCreditsChange.emit(this._credits);
        },
        (error: any) => {
        }
      )
  }

  ngOnDestroy() {
    this.destroy$.unsubscribe();
  }

}
